import React from "react";
import { motion } from "framer-motion";

export default function StatGrid({ items = [] }) {
  return (
    <section className="erp-stat-grid">
      {items.map((item, index) => {
        const Icon = item.icon;
        return (
          <motion.article
            key={item.title}
            className="erp-stat-card"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05, duration: 0.28 }}
            whileHover={{ y: -5 }}
            whileTap={{ scale: 0.985 }}
          >
            <div className="erp-stat-head">
              <div>
                <div className="erp-stat-label">{item.title}</div>
                <div className="erp-stat-value">{item.value}</div>
              </div>
              {Icon ? (
                <div className="erp-stat-icon">
                  <Icon size={18} />
                </div>
              ) : null}
            </div>
            <div className="erp-stat-foot">
              <span className="erp-stat-meta">{item.meta}</span>
              {item.trend ? (
                <span className={`erp-pill ${item.tone || ""}`}>{item.trend}</span>
              ) : null}
            </div>
          </motion.article>
        );
      })}
    </section>
  );
}
